export const URL_MAP = {
    'selenium': {
        0: 'what-is-selenium',
        1: 'selenium-and-react',
    },
    'enzyme': {
        0: 'what-is-enzyme'
    },
    'javascript-mechanics': {
        0: 'syntax-parser',
        1: 'lexical-environment',
        2: 'execution-context',
    },
    'how-to': {
        0: 'add-javascript',
        1: 'add-sass',
        2: 'run-a-local-server',
    },
    concepts: {
        0: 'javascript/classes',
        1: 'javascript/scope',
        2: 'javascript/this',
        3: 'javascript/var-let-const',
        4: 'javascript/data-types',
        5: 'javascript/prototypes',
        6: 'javascript/synchronous',
    },
    jest: {
        0: 'what-is-jest',
        1: 'snapshot-tests',
        2: 'writing-a-test',    
    },
    courses: {
        'javascript-basics': {
            introduction: {
                0: 'overview',
                1: 'what-is-javascript',
                2: 'what-can-you-do-with-javascript',
            },
            'adding-javascript': {
                0: 'script-tags',
                1: 'separate-file',
                2: 'summary',
            },
            'basic-definition': {
                0: 'variables',
                1: 'console-messages',
            },
            'operators': {
                0: 'introduction',
                1: 'type-inference',
                2: 'assignment-operator',
                3: 'comparison-operator',
                4: 'logical-operator',
                5: 'maths-operator'
            },
            'document-object-model': {
                0: 'what-is-the-dom',
                1: 'manipulating-the-dom',
            }
        },
    }
}